import React, { useState } from "react"
import Formsy from "formsy-react"
import types from "prop-types"
import { Button, PrimaryButton } from "shared/buttons"
import SubmissionEditFormDisclaimer from "./SubmissionEditFormDisclaimer"
import SubmissionEditSection from "./SubmissionEditSection"

function SubmissionEditForm({
  answers, onCancel, onSubmit, sections,
}) {
  const [canSubmit, setCanSubmit] = useState(false)
  const [currentAnswers, setCurrentAnswers] = useState(answers)

  const enableSubmit = () => setCanSubmit(true)
  const disableSubmit = () => setCanSubmit(false)

  return (
    <Formsy
      id="submission-edit-form"
      className="flex flex-col gap-4"
      autoComplete="off"
      onChange={setCurrentAnswers}
      onSubmit={onSubmit}
      onValid={enableSubmit}
      onInvalid={disableSubmit}
      preventDefaultSubmit
    >
      <div>
        {
          sections.map((section, sectionIndex) => (
            <SubmissionEditSection
              key={section.uuid}
              section={section}
              formAnswers={currentAnswers}
              isFirstSection={sectionIndex === 0}
            />
          ))
        }
      </div>
      <SubmissionEditFormDisclaimer />
      <div className="flex justify-center">
        <Button
          className="border border-light mr-4"
          onClick={onCancel}
          text="Cancel"
        />
        <PrimaryButton
          disabled={!canSubmit}
          text="Save"
          type="submit"
        />
      </div>
    </Formsy>
  )
}

SubmissionEditForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  answers: types.object.isRequired,
  onCancel: types.func.isRequired,
  onSubmit: types.func.isRequired,
  sections: types.arrayOf(types.object).isRequired,
}

export default SubmissionEditForm
